import { render, staticRenderFns } from "./AnnouncementPopup.vue?vue&type=template&id=a727b46c&scoped=true"
import script from "./AnnouncementPopup.vue?vue&type=script&lang=js"
export * from "./AnnouncementPopup.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPopup.vue?vue&type=style&index=0&id=a727b46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a727b46c",
  null
  
)

export default component.exports